
































import Vue from 'vue'
import gql from 'graphql-tag'
import InputField from '@/components/atoms/InputField.vue'
import { MdButton, MdCard, MdCheckbox, MdLayout, MdSnackbar } from 'vue-material/dist/components'

Vue.use(MdButton)
Vue.use(MdCard)
Vue.use(MdCheckbox)
Vue.use(MdLayout)
Vue.use(MdSnackbar)
export default Vue.extend({
  name: 'PasswordSendInstructions',
  props: {
  },
  data: () => ({
    email: '' as string,
    error: '' as string,
    sending: false
  }),
  components: {
    InputField
  },
  computed: {
    showError (): boolean {
      return !!this.error && this.error !== ''
    }
  },
  methods: {
    submit: async function () {
      try {
        if (this.sending || !this.email) return

        this.sending = true

        try {
          const request = await this.$apollo.mutate({
            // Query
            mutation: gql`mutation {
              forgotPassword(
                body: {
                  email: "${this.email}"
                }
              ) {
                changePasswordId
              }
            }`
          })
          if (request.data?.forgotPassword?.changePasswordId || !request.data?.error) {
            // TODO: Use changePasswordId from response
            this.error = ''
            this.$emit('submitted', this.email)
          } else {
            throw new Error(request.data?.error)
          }
        } catch (errors) {
          this.error = errors
        } finally {
          this.sending = false
        }
      } catch (errors) {
        this.error = errors
      }
    }
  }
})
